export default __webpack_public_path__ + "static/media/4.953e4078.jpg";